import { render, staticRenderFns } from "./zBuscarCliente.vue?vue&type=template&id=1199d89c&scoped=true&"
import script from "./zBuscarCliente.vue?vue&type=script&lang=js&"
export * from "./zBuscarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1199d89c",
  null
  
)

export default component.exports